import { render, staticRenderFns } from "./error_404.vue?vue&type=template&id=34c21547&scoped=true&"
import script from "./error_404.vue?vue&type=script&lang=js&"
export * from "./error_404.vue?vue&type=script&lang=js&"
import style0 from "./error_404.vue?vue&type=style&index=0&id=34c21547&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c21547",
  null
  
)

export default component.exports